import sha256 from 'crypto-js/sha256';
import { v4 as uuidv4 } from 'uuid';
import Pusher from 'pusher-js';
import { $stateParams } from '../../../../router';
import { keys } from '../SocketService';
import AdminService from '../AdminService';
import RegionService from '../RegionService';

import {
	ATTENDEE_SUBSCRIBED_EVENT,
	ATTENDEE_ADDED_EVENT,
	ATTENDEE_REMOVED_EVENT,
	ATTENDEE_EJECTED_EVENT,
	MESSAGE_ADDED_EVENT,
	MESSAGE_REMOVED_EVENT,
	MESSAGE_HIGHLIGHTED_EVENT,
	HOST_HIGHLIGHTED_EVENT,
	VIDEO_EMOJI_HEART_EVENT,
    VIDEO_EMOJI_SMILE_EVENT,
    VIDEO_EMOJI_THUMBS_UP_EVENT
} from '../../constants';
import { Trigger } from '../_';

const regionUrl = {
	'eu'    : 'https://api-eu.geckoform.com',
	'us-e'  : 'https://api-us-e.geckoform.com',
	'stage' : 'https://api-stage.geckoform.com',
	'local' : 'http://localhost:8000',
};

let pusher, channel;

export const PresenceSocketService = {

	channel: () => channel || null,

	init: (name = null) => {
		const region = RegionService.getRegion();
		const key    = AdminService.isAdmin() ? uuidv4() : $stateParams.contact_uuid;
		const secret = $stateParams.contact_uuid;
		const params = {
            pusher_signature: sha256(key+'-'+secret),
            pusher_token_key: key
        };
        if (name) params.name = name;

		const config = {
        	cluster: region === 'us-e' ? undefined : 'eu',
        	encrypted: true,
	        authEndpoint: `${regionUrl[region]}/stream/${$stateParams.account_uuid}/${$stateParams.contact_uuid}/${$stateParams.event_id}/pusher`,
	        authTransport: 'ajax',
	        auth: {
	            params: params,
	        }
        };

        pusher = new Pusher(keys[region], config);
        channel = pusher.subscribe(`presence-video-stream-${$stateParams.account_uuid}-${$stateParams.event_id}`);

        // Map pusher events to event service
        channel.bind('pusher:subscription_succeeded', () => {
        	// Subscribed to Presence
        	Trigger(ATTENDEE_SUBSCRIBED_EVENT);
        	// Attendee List
	        channel.bind(ATTENDEE_ADDED_EVENT, () => Trigger(ATTENDEE_ADDED_EVENT));
	        channel.bind(ATTENDEE_REMOVED_EVENT, () => Trigger(ATTENDEE_REMOVED_EVENT));
	        channel.bind(ATTENDEE_EJECTED_EVENT, (message) => Trigger(ATTENDEE_EJECTED_EVENT, message));
	        // Messages
	        channel.bind(MESSAGE_ADDED_EVENT, (message) => Trigger(MESSAGE_ADDED_EVENT, message));
	        channel.bind(MESSAGE_REMOVED_EVENT, (message) => Trigger(MESSAGE_REMOVED_EVENT, message));
	        channel.bind(MESSAGE_HIGHLIGHTED_EVENT, (message) => Trigger(MESSAGE_HIGHLIGHTED_EVENT, message));
	        // Hosts
	        channel.bind(HOST_HIGHLIGHTED_EVENT, (host) => Trigger(HOST_HIGHLIGHTED_EVENT, host));
			// Reactions
			channel.bind(VIDEO_EMOJI_HEART_EVENT, (params) => Trigger(VIDEO_EMOJI_HEART_EVENT, params));
			channel.bind(VIDEO_EMOJI_SMILE_EVENT, (params) => Trigger(VIDEO_EMOJI_SMILE_EVENT, params));
			channel.bind(VIDEO_EMOJI_THUMBS_UP_EVENT, (params) => Trigger(VIDEO_EMOJI_THUMBS_UP_EVENT, params));
        });
        return Promise.resolve();
	},

	destroy: () => {
		if (channel) {
			channel.unbind();
			pusher.unsubscribe(`presence-video-stream-${$stateParams.account_uuid}-${$stateParams.event_id}`);
		}
		return Promise.resolve();
	},

	trigger: (name, data = {}) => {
		// Trigger for everyone else
		channel.trigger(name, data);
		// Trigger for me
		Trigger(name, data);
	},

};

export default PresenceSocketService;